export const capitalize = (str?: string) => str && str[0].toUpperCase() + str.toLowerCase().slice(1);
